import { assoc, compose, dissoc, pick, prop } from 'ramda'

const setEntity = data => item => (data?.data?.entity ? assoc('entity', data.data.entity, item) : dissoc('entity', item))

export const cleanRequest = (form, data) => {
  if (data?.data?.entity === 'assets') {
    return compose(
      pick(['id', 'name', 'placeLevelIds', 'assetTypeIds', 'entity']), //
      setEntity(data),
      assoc('assetTypeIds', (form.assetTypeIds || []).map(prop('id'))),
      assoc('placeLevelIds', (form.placeLevels || []).map(prop('id')))
    )(form)
  }

  return compose(
    pick(['id', 'name', 'placeLevelIds', 'placeTypes', 'entity']), //
    setEntity(data),
    assoc('placeLevelIds', (form.placeLevels || []).map(prop('id'))),
    assoc('placeTypes', [data.data.placeType])
  )(form)
}
